import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import locale from "locale";
import { LinkContainer } from "react-router-bootstrap";
import { Row, Col, Breadcrumb, ButtonToolbar, Button } from "react-bootstrap";

import { requestGetStatistic } from "../../../../api/cp";
import StatisticsContent from "./components/StatisticsContent";

const ReminderStatistics = ({ event }) => {
    const { reminderId } = useParams();
    const BACK_LINK = `/event/${event.eventPassword}/edit-reminders`;

    const [statistics, setStatistics] = useState([]);

    useEffect(onShowStatistics, []);

    async function onShowStatistics() {
        try {
            const response = await requestGetStatistic(reminderId);
            setStatistics(response);
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error onShowStatistic"
            );
        }
    }

    return (
        <section>
            <Row>
                <Col>
                    <Breadcrumb>
                        <LinkContainer to={`/event/${event.eventPassword}`}>
                            <Breadcrumb.Item>
                                {locale("reminders.broadcast")}
                            </Breadcrumb.Item>
                        </LinkContainer>
                        <LinkContainer to={BACK_LINK}>
                            <Breadcrumb.Item>
                                {locale("reminders.mailing")}
                            </Breadcrumb.Item>
                        </LinkContainer>
                        <Breadcrumb.Item active>Статистика</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>

            <StatisticsContent statistics={statistics} />

            <Row style={{ marginTop: "96px" }}>
                <Col xs={12}>
                    <ButtonToolbar>
                        <LinkContainer to={BACK_LINK}>
                            <Button>{locale("reminders.back")}</Button>
                        </LinkContainer>
                    </ButtonToolbar>
                </Col>
            </Row>

        </section>
    );
};

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(ReminderStatistics);
